import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';

const Content = styled.div`
  font-size: 16px;
`;

interface Props {
  title: string;
  content: string | React.ReactNode;
  children: (open: Function) => React.ReactNode;
  onOk: (close: Function) => void;
  closable?: boolean;
  onCancel?: () => void;
}

const Confirmation: React.FC<Props> = ({ onOk, children, title, content, closable, onCancel }) => {
  const [isVisible, setVisible] = React.useState(false);

  const handleOk = () => {
    onOk(() => setVisible(false));
  };

  const handleCancel = () => {
    setVisible(false);
    if (onCancel) onCancel();
  };
  return (
    <>
      <Modal
        closable={closable}
        onOk={handleOk}
        width={500}
        open={isVisible}
        onCancel={handleCancel}
        title={title}
        okText="Confirm"
        cancelText="Close"
      >
        <Content>{content}</Content>
      </Modal>
      {children(() => setVisible(true))}
    </>
  );
};

export default Confirmation;
